import React from 'react';
import { DatePicker } from 'antd';
import { cn } from './_cn';
import FieldLabel from './field-label';

const TWDatePicker = ({
  label,
  labelIcon,
  error,
  hint,
  size = 'large',
  format = 'MM/DD/YYYY',
  required,
  id,
  className = '',
  wrapperClassName = '',
  ...rest
}) => {
  const generatedId = React.useId();
  const pickerId = id || generatedId;
  const hasError = Boolean(error);
  return (
    <div className={cn('w-full', wrapperClassName)}>
      {label ? (
        <FieldLabel htmlFor={pickerId} icon={labelIcon} required={required}>
          {label}
        </FieldLabel>
      ) : null}
      <DatePicker
        id={pickerId}
        size={size}
        style={{ width: '100%' }}
        format={format}
        status={hasError ? 'error' : undefined}
        className={cn('tw-picker', className)}
        {...rest}
      />
      {error || hint ? (
        <p
          className={cn(
            'mt-1 text-xs',
            hasError
              ? 'text-rose-600 dark:text-rose-400'
              : 'text-slate-500 dark:text-slate-400',
          )}
        >
          {error || hint}
        </p>
      ) : null}
    </div>
  );
};

export default TWDatePicker;
